import { z } from "zod";

export const roleStatusValues = ["draft", "active", "archived"] as const;
export type RoleStatus = (typeof roleStatusValues)[number];

const nameSchema = z.string().min(1, "Name is required").max(120);
const descriptionSchema = z.string().max(2000).nullable().optional();
const urlSchema = z
  .union([z.string().url("Must be a valid URL"), z.literal("").transform(() => null)])
  .nullable()
  .optional();

// Field set WITHOUT the status default — the base for both variants. zod's
// .partial() still applies .default() values for absent keys, so a defaulted
// update schema would re-inject status:"draft" into every partial edit and
// silently de-activate an active role. The default lives only on create.
const roleFieldsSchema = z.object({
  name: nameSchema,
  description: descriptionSchema,
  pillarId: z.string().uuid().nullable().optional(),
  departmentId: z.string().uuid().nullable().optional(),
  roleTeamId: z.string().uuid().nullable().optional(),
  jobDescriptionUrl: urlSchema,
  status: z.enum(roleStatusValues),
});

export const roleCreateSchema = roleFieldsSchema.extend({
  status: z.enum(roleStatusValues).default("draft"),
});

export const roleUpdateSchema = roleFieldsSchema.partial();

export type RoleCreateInput = z.infer<typeof roleCreateSchema>;
export type RoleUpdateInput = z.infer<typeof roleUpdateSchema>;
